<div class="fixed-bottom footerColor">
  <div class="text-center">
    <small>
      © 2019
      <a href="http://cbml.ds.unipi.gr/" target="_blank">
        Computational Biomedicine Research Lab
      </a>(Version {{VERSION}})
    </small>
  </div>
</div>
